/**
 * 設備配置（Profile）vs 通道配置（chargingBasket）分離 SSOT。
 * 側欄 menu design 與角色授權樹共用；勾選 id 須為 coffee_menu 真實 id。
 */
export const LEGACY_DEVICE_CONFIG_ROOT_ID = '1721413909652439040'
/** DB 通道配置（patch 187 · 挂出品管理下）；勿用 990295（X600H 编辑生产订单按钮） */
export const CHANNEL_CONFIG_CATALOG_ID = '990431'
/** 出品管理根（coffee_menu productCenter） */
export const PRODUCT_CENTER_ROOT_ID = '1721413909669216256'
/** 側欄合成設備配置分組（非 DB id，僅側欄展示） */
export const DEVICE_CONFIG_SIDEBAR_GROUP_ID = '990100'

export const DEVICE_CONFIG_EXCLUSIVE_EN = new Set([
  'configProfileLibrary',
  'configBindDispatch'
])

export const CHANNEL_CONFIG_EXCLUSIVE_EN = new Set([
  'configDistribute',
  'devicesChannels',
  'channelCategory'
])

export const DEVICE_CONFIG_EXCLUSIVE_IDS = new Set([
  '1900410300000000001',
  '1900410300000000002'
])

export function menuNodeEnName (n) {
  return n && n.enName != null ? String(n.enName).trim() : ''
}

export function isDeviceConfigExclusiveLeaf (n) {
  if (!n) return false
  const en = menuNodeEnName(n)
  if (en && DEVICE_CONFIG_EXCLUSIVE_EN.has(en)) return true
  if (DEVICE_CONFIG_EXCLUSIVE_IDS.has(String(n.id))) return true
  const url = String(n.url || '')
  return url.indexOf('deviceConfig/') >= 0
}

export function isChannelConfigExclusiveLeaf (n) {
  if (!n) return false
  const en = menuNodeEnName(n)
  const url = String(n.url || '')
  if (en && CHANNEL_CONFIG_EXCLUSIVE_EN.has(en)) return true
  if (en === 'channelCategory' && url.indexOf('chargingBasket') >= 0) return true
  return url.indexOf('chargingBasketManagement/') >= 0
}

/** 歷史混掛根：仍含通道葉子時才剝離（087 後僅 Profile 則保留為設備配置根） */
export function isMixedLegacyDeviceConfigRoot (n) {
  if (!n || n.id == null) return false
  if (String(n.id) === LEGACY_DEVICE_CONFIG_ROOT_ID) {
    const kids = n.menuList || n.childrens || []
    return kids.some(isChannelConfigExclusiveLeaf)
  }
  const en = menuNodeEnName(n)
  if (en === 'deviceConfig' && String(n.id) !== DEVICE_CONFIG_SIDEBAR_GROUP_ID) {
    const hasUrl = n.url != null && /\S/.test(String(n.url))
    if (!hasUrl) {
      const kids = n.menuList || n.childrens || []
      return kids.some(isChannelConfigExclusiveLeaf)
    }
  }
  return false
}

export function partitionDeviceChannelLeaves (children) {
  const deviceLeaves = []
  const channelLeaves = []
  ;(children || []).forEach((c) => {
    if (!c) return
    if (isDeviceConfigExclusiveLeaf(c)) deviceLeaves.push(c)
    else if (isChannelConfigExclusiveLeaf(c)) channelLeaves.push(c)
    else channelLeaves.push(c)
  })
  return { deviceLeaves, channelLeaves }
}

/**
 * 角色授權樹：混掛 legacy 根拆出通道叶；通道配置挂出品管理下（patch 187）。
 * 若 DB 已有 990431 通道根則跳過。
 */
export function splitDeviceChannelRoleSkeleton (roots) {
  if (!Array.isArray(roots) || !roots.length) return roots
  if (roots.some((r) => r && String(r.id) === CHANNEL_CONFIG_CATALOG_ID)) return roots

  const idx = roots.findIndex((r) => r && String(r.id) === LEGACY_DEVICE_CONFIG_ROOT_ID)
  if (idx < 0) return roots

  const legacy = roots[idx]
  const { deviceLeaves, channelLeaves } = partitionDeviceChannelLeaves(legacy.menuList || [])
  if (!channelLeaves.length) return roots

  const out = roots.slice()
  if (deviceLeaves.length) {
    out[idx] = Object.assign({}, legacy, { enName: 'deviceConfig', menuList: deviceLeaves })
  } else {
    out.splice(idx, 1)
  }

  const channelFolder = {
    id: CHANNEL_CONFIG_CATALOG_ID,
    name: '通道配置',
    enName: 'channelConfiguration',
    type: 0,
    parentId: PRODUCT_CENTER_ROOT_ID,
    sort: 40,
    menuList: channelLeaves
  }
  const pcIdx = out.findIndex(
    (r) => r && (String(r.id) === PRODUCT_CENTER_ROOT_ID || menuNodeEnName(r) === 'productCenter')
  )
  if (pcIdx >= 0) {
    const pc = out[pcIdx]
    const kids = Array.isArray(pc.menuList) ? pc.menuList.slice() : []
    if (!kids.some((c) => c && String(c.id) === CHANNEL_CONFIG_CATALOG_ID)) {
      kids.push(channelFolder)
    }
    out[pcIdx] = Object.assign({}, pc, { menuList: kids })
  } else {
    out.push(channelFolder)
  }
  return out
}



// WEBPACK FOOTER //
// ./src/utils/deviceChannelMenuSplit.js